import plugin_vue3_liVSIkOT7p from "/home/runner/work/octo/octo/node_modules/.pnpm/@pinia+nuxt@0.4.6_typescript@4.7.4/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/home/runner/work/octo/octo/.nuxt/components.plugin.mjs";
import vueuse_head_plugin_lVUuMazdfx from "/home/runner/work/octo/octo/node_modules/.pnpm/nuxt@3.2.0_dq2illufn2sdyxstnqbjq3sy6i/node_modules/nuxt/dist/head/runtime/lib/vueuse-head.plugin.mjs";
import router_WKhZlhWSeQ from "/home/runner/work/octo/octo/node_modules/.pnpm/nuxt@3.2.0_dq2illufn2sdyxstnqbjq3sy6i/node_modules/nuxt/dist/pages/runtime/plugins/router.mjs";
import prefetch_client_KyCxTqlqDL from "/home/runner/work/octo/octo/node_modules/.pnpm/nuxt@3.2.0_dq2illufn2sdyxstnqbjq3sy6i/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.mjs";
import templates_pwa_client_3297f330_IX8jpbbhfZ from "/home/runner/work/octo/octo/.nuxt/templates.pwa.client.3297f330.ts";
import payload_client_2fjLZ4qBO7 from "/home/runner/work/octo/octo/node_modules/.pnpm/nuxt@3.2.0_dq2illufn2sdyxstnqbjq3sy6i/node_modules/nuxt/dist/app/plugins/payload.client.mjs";
import dev_Zc585R5Y2V from "/home/runner/work/octo/octo/plugins/dev.ts";
import mq_9h3c4HK3CS from "/home/runner/work/octo/octo/plugins/mq.ts";
import pinia_client_l2mvTNw9P0 from "/home/runner/work/octo/octo/plugins/pinia.client.ts";
import plugins_gZVkQZouNK from "/home/runner/work/octo/octo/plugins/plugins.ts";
import vuex_F8JCgj45hr from "/home/runner/work/octo/octo/plugins/vuex.ts";
export default [
  plugin_vue3_liVSIkOT7p,
  components_plugin_KR1HBZs4kY,
  vueuse_head_plugin_lVUuMazdfx,
  router_WKhZlhWSeQ,
  prefetch_client_KyCxTqlqDL,
  templates_pwa_client_3297f330_IX8jpbbhfZ,
  payload_client_2fjLZ4qBO7,
  dev_Zc585R5Y2V,
  mq_9h3c4HK3CS,
  pinia_client_l2mvTNw9P0,
  plugins_gZVkQZouNK,
  vuex_F8JCgj45hr
]